class MagneticBtn {

    constructor() {

        const ui = {
            btn: document.querySelector('.c-magnetic-btn'),
            label: document.querySelector('.t-btn-label')
        }
        this.ui = ui;

        const state = {
            bounds: ui
                .btn
                .getBoundingClientRect(),
            threshold: parseInt(ui.btn.dataset.threshold),
            ratio: parseInt(ui.btn.dataset.ratio),
            isMagnetic: false,
            mouse: {
                x: 0,
                y: 0
            },
            ease: {
                x: 0,
                y: 0,
                scale: 1,
                value: ui.btn.dataset.ease
            },
            transform: {
                x: 0,
                y: 0,
                scale: 1,
                max: ui.btn.dataset.max
            },
            width: window.innerWidth,
            height: window.innerHeight,
            history: false,
            scale: ui.btn.dataset.scale
        }
        this.state = state;

    }

    onMouseMove({
        pageX,
        pageY
    }) {
        const isMagnetic = this.isMagnetic(pageX, pageY);
        Object.assign(this.state, {
            mouse: {
                x: pageX,
                y: pageY
            },
            isMagnetic: isMagnetic
        })
    }

    resize() {
        Object.assign(state, {
            bounds: ui
                .btn
                .getBoundingClientRect(),
            width: window.innerWidth,
            height: window.innerHeight
        })
    }

    isMagnetic(x, y) {
        const {
            bounds
        } = this.state

        const centerX = bounds.left + (bounds.width / 2)
        const centerY = bounds.top + (bounds.height / 2)

        // use pythagorean theorem to calculate cursor distance from center of btn a^2 +
        // b^2 = c^2
        const a = Math.abs(centerX - x)
        const b = Math.abs(centerY - y)
        const c = Math.sqrt(a * a + b * b)

        // true if cursor distance from center of btn is equal to btn radius + threshold
        const isHover = c < (bounds.width / 2) + this.state.threshold

        if (!this.state.history && isHover) {
            this
                .ui
                .btn
                .classList
                .add('is-hover')
            Object.assign(this.state, {
                threshold: this.state.threshold * this.state.ratio,
                history: true
            })
        } else if (this.state.history && !isHover) {
            this
                .ui
                .btn
                .classList
                .remove('is-hover')
            Object.assign(this.state, {
                threshold: this.state.threshold / this.state.ratio,
                history: false
            })
        }

        return isHover
    }

    run() {
        requestAnimationFrame(this.run.bind(this))

        const {
            isMagnetic,
            transform,
            mouse,
            width,
            height,
            ease,
            max,
            scale
        } = this.state

        transform.x = isMagnetic ?
            (mouse.x - width / 2) / width * transform.max :
            0
        transform.y = isMagnetic ?
            (mouse.y - height / 2) / height * transform.max - 180 :
            0
        transform.scale = isMagnetic ?
            scale :
            1

        // basic linear interpolation https://www.youtube.com/watch?v=yWhgniVHROw
        ease.x += (transform.x - ease.x) * ease.value
        ease.y += (transform.y - ease.y) * ease.value
        ease.scale += (transform.scale - ease.scale) * ease.value

        Object.assign(this.ui.btn.style, {
            transform: `
			translate(
				${ease
                .x
                .toFixed(2)}px,
				${ease
                .y
                .toFixed(2)}px
			)
			translateZ(0)
			scale(
				${ (ease.scale)
                .toFixed(2)}
			)`
        })

        Object.assign(this.ui.label.style, {
            transform: `
			translate(
				${ (-ease.x / this.state.ratio).toFixed(2)}px,
				${ (-ease.y / this.state.ratio).toFixed(2)}px
			)
			translateZ(0)
			scale(
				${ (1 / ease.scale).toFixed(2)}
			)`
        })
    }

    init() {
        document.addEventListener('mousemove', this.onMouseMove.bind(this))
        //window.addEventListener('resize', resize)
        this.run()
    }

}

export default MagneticBtn


// WEBPACK FOOTER //
// ./src/js/components/MagneticBtn.js